const MAX_MULTIPLE_SLIDES_COUNT = 4;

const cardSlider = document.querySelectorAll('.card__slider');
const defaultSliderOptions = {
  speed: 2200,
  watchOverflow: true,
  observer: true,
  resizeObserver: true
};

const initSlider = (elem) => {
  if (!elem) return;

  const countsElements = elem.querySelectorAll('.card__slide-wrapper').length;
  const sliderOptions = {...defaultSliderOptions};

  const sliderWrapper = elem.parentElement;
  const navigationButtonNext = sliderWrapper.querySelector('.card__slider-button--next');
  const navigationButtonPrev = sliderWrapper.querySelector('.card__slider-button--prev');
  const pagination = sliderWrapper.querySelector('.card__slider-pagination');

  sliderOptions.navigation = {
    nextEl: navigationButtonNext,
    prevEl: navigationButtonPrev,
  };

  sliderOptions.pagination = {
    el: pagination,
    type: 'bullets',
    bulletClass: 'card__slider-pagination-item',
    bulletActiveClass: 'card__slider-pagination-item--active',
    clickable: true
  };

  if (elem.hasAttribute('data-autoplay')) {
    sliderOptions.autoplay = {
      delay: 2200,
      disableOnInteraction: false
    };
  }

  if (elem.dataset.slidesPerView) {
    const slidesPerView = elem.dataset.slidesPerView; // кол-во слайдов на экране

    sliderOptions.loop = (countsElements > slidesPerView);
    sliderOptions.autoHeight = false;
    sliderOptions.spaceBetween = 40;
    sliderOptions.breakpoints = {
      0: {
        slidesPerView: 1
      },
      480: {
        slidesPerView: (slidesPerView > MAX_MULTIPLE_SLIDES_COUNT) ? 2 : 1
      },
      768: {
        slidesPerView: (slidesPerView > MAX_MULTIPLE_SLIDES_COUNT) ? 3 : 2
      },
      992: {
        slidesPerView: (slidesPerView > MAX_MULTIPLE_SLIDES_COUNT) ? 4 : 2
      },
      1326: {
        slidesPerView: slidesPerView,
      }
    };
  } else {
    sliderOptions.effect = 'fade';
    sliderOptions.fadeEffect = {
      crossFade: true
    };
    sliderOptions.loop = (countsElements > 1);
    sliderOptions.autoHeight = (countsElements > 1);
  }

  const swiper = new Swiper(elem, sliderOptions);
};

if (cardSlider.length > 0) {
  cardSlider.forEach((elem) => {
    initSlider(elem);
  });
}